export default __webpack_public_path__ + "static/media/lock.0e3fe38d.svg";